import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const SelectWorksiteDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  entity: {},
  onSelect: () => null,
  title: null,
};

export const SelectWorksitePropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  entity: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    worksite: PropTypes.oneOfType([
      PropTypes.shape({
        code: PropTypes.string,
        label: PropTypes.string,
      }),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  onSelect: PropTypes.func,
  title: PropTypes.string,
};
